import { render, staticRenderFns } from "./TechSecretaryHome.vue?vue&type=template&id=3f6872e0&scoped=true&"
import script from "./TechSecretaryHome.vue?vue&type=script&lang=js&"
export * from "./TechSecretaryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6872e0",
  null
  
)

export default component.exports